import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';


export function validateOfferNotGreater(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const standard = parseFloat(group.get('Course_Standard_Price')?.value);
    const offer = parseFloat(group.get('Course_Current_Offer_Price')?.value);

    if(standard!==0 || offer!==0){
    if (!isNaN(standard) && !isNaN(offer) && offer >= standard) {
      return { greaterThanStandard: true };
    }}
    return null;
  };
}



export function VSubject(
  control: AbstractControl
): { [key: string]: any } | null {
  if (!control.value) {
    return { VSubject: true };
  }
  return null;
}

export function VResourceAssign(
  control: AbstractControl
): { [key: string]: any } | null {
  if (!control.value) {
    return { VResourceAssign: true };
  }
  return null;
}

export function VAddQuestion(
  control: AbstractControl
): { [key: string]: any } | null {
  if (!control.value) {
    return { VAddQuestion: true };
  }
  return null;
}

export function VAddQuestionBody(
  control: AbstractControl
): { [key: string]: any } | null {
  if (!control.value) {
    return { VAddQuestionBody: true };
  }
  return null;
}
export function VAddAnswerChoice(
  control: AbstractControl
): { [key: string]: any } | null {
  if (!control.value) {
    return { VAddAnswerChoice: true };
  }
  return null;
}
export function VAddAnswerChoiceNote(
  control: AbstractControl
): { [key: string]: any } | null {
  if (!control.value) {
    return { VAddAnswerChoiceNote: true };
  }
  return null;
}
export function VStudyUnit(
  control: AbstractControl
): { [key: string]: any } | null {
  if (!control.value) {
    return { VStudyUnit: true };
  }
  return null;
}

export function VRemoveResource(
  control: AbstractControl
): { [key: string]: any } | null {
  // let checked=0;
  // let minRequired=1;
  // let count;
  if (!control.value) {
    return { VRemoveResource: true };
  }
  // else{
  //   checked++;
  //   count+=1;
  // }
  // if(this.checked<this.minRequired)
  // {

  // }
  // else{
  return null;
}
export function VStudyMaterial(
  control: AbstractControl
): { [key: string]: any } | null {
  if (!control.value) {
    return { VStudyMaterial: true };
  }
  return null;
}
export function VADDStudyMaterial(
  control: AbstractControl
): { [key: string]: any } | null {
  if (!control.value) {
    return { VADDStudyMaterial: true };
  }
  return null;
}

export function maxValueValidator(
  controlName: string,
  compareControlName: string
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const formGroup = control as FormGroup;
    const controlValue = formGroup.get(controlName)?.value;
    const compareControlValue = formGroup.get(compareControlName)?.value;

    if (controlValue > compareControlValue) {
      return { maxValueError: `${compareControlName} cannot be greater than ${controlName}` };
    }

    return null;
  };
}

export function sameCourseValidator(value:boolean): ValidatorFn {
  return (control: AbstractControl) => {
    return { sameCourse: value }; // Indicates a validation error
  };
}
